import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import TestsList from "@/pages/TestsList";
import TestRunner from "@/pages/TestRunner";
import TestResult from "@/pages/TestResult";
import Progress from "@/pages/Progress";
import ParentDashboard from "@/pages/ParentDashboard";
import Admin from "@/pages/Admin";
import AppShell from "@/components/AppShell";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function FullPageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-parchment">
      <div className="caption text-slate">Načítání…</div>
    </div>
  );
}

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!user) return <Landing />;
  if (user.role === "parent") return <Navigate to="/rodic" replace />;
  if (user.role === "admin") return <Navigate to="/testy" replace />;
  return <Navigate to="/prehled" replace />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RoleHome />} />
            <Route path="/tests" element={<Navigate to="/testy" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registrace" element={<Register />} />

            <Route element={<AppShell />}>
              <Route path="/prehled" element={
                <ProtectedRoute roles={["student"]}><Dashboard /></ProtectedRoute>
              } />
              <Route path="/testy" element={
                <ProtectedRoute roles={["student", "admin"]}><TestsList /></ProtectedRoute>
              } />
              <Route path="/pokrok" element={
                <ProtectedRoute roles={["student"]}><Progress /></ProtectedRoute>
              } />
              <Route path="/rodic" element={
                <ProtectedRoute roles={["parent"]}><ParentDashboard /></ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>
              } />
            </Route>

            <Route path="/test/:attemptId" element={
              <ProtectedRoute roles={["student", "admin"]}><TestRunner /></ProtectedRoute>
            } />
            <Route path="/vysledek/:attemptId" element={
              <ProtectedRoute roles={["student", "admin"]}><TestResult /></ProtectedRoute>
            } />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
